import { combineEpics, ofType } from "redux-observable";
import { mergeMap, catchError } from "rxjs/operators";
import { of } from "rxjs";
import {
  observableDELETE,
  observableGET,
  observablePUT
} from "@/api/apiClient";
import {
  subscriptionPlanRequest,
  subscriptionPlanSuccess,
  subscriptionPlanFailure,
  userSubscriptionPaymentRequest,
  userSubscriptionPaymentSuccess,
  userSubscriptionPaymentFailure,
  getUserSubscriptionRequest,
  getUserSubscriptionSuccess,
  getUserSubscriptionFailure,
  cancelUserSubscriptionRequest,
  cancelUserSubscriptionSuccess,
  cancelUserSubscriptionFailure,
  getUserSubscriptionHistoryRequest,
  getUserSubscriptionHistorySuccess,
  getUserSubscriptionHistoryFailure,
  createCustomerPortalSessionRequest,
  createCustomerPortalSessionSuccess,
  createCustomerPortalSessionFailure
} from "./userSubscription";

const subscriptionPlanRequestEpic = (action$) =>
  action$.pipe(
    ofType(subscriptionPlanRequest.type),
    mergeMap(() => {
      return observableGET(`/subscription-plan`).pipe(
        mergeMap((response) => {
          return of(subscriptionPlanSuccess(response.data));
        }),
        catchError((error) => of(subscriptionPlanFailure(error)))
      );
    })
  );

const userSubscriptionPaymentEpic = (action$) =>
  action$.pipe(
    ofType(userSubscriptionPaymentRequest.type),
    mergeMap((action) => {
      return observablePUT(`/subscription/upgrade`, {
        body: action.payload
      }).pipe(
        mergeMap((response) => {
          return of(userSubscriptionPaymentSuccess(response.data));
        }),
        catchError((error) => of(userSubscriptionPaymentFailure(error)))
      );
    })
  );

export const getUserSubscriptionEpic = (action$) =>
  action$.pipe(
    ofType(getUserSubscriptionRequest.type),
    mergeMap((action) => {
      const { uuid } = action.payload;
      return observableGET(`/subscription/user-by-uuid/${uuid}`).pipe(
        mergeMap((response) => of(getUserSubscriptionSuccess(response.data))),
        catchError((error) => of(getUserSubscriptionFailure(error)))
      );
    })
  );

export const cancelUserSubscriptionEpic = (action$) =>
  action$.pipe(
    ofType(cancelUserSubscriptionRequest.type),
    mergeMap((action) => {
      const { uuid } = action.payload;
      return observableDELETE(`/subscription/cancel/${uuid}`).pipe(
        mergeMap(() =>
          of(
            cancelUserSubscriptionSuccess(),
            getUserSubscriptionRequest({ uuid })
          )
        ),
        catchError((error) => of(cancelUserSubscriptionFailure(error)))
      );
    })
  );

export const getUserSubscriptionHistoryEpic = (action$) =>
  action$.pipe(
    ofType(getUserSubscriptionHistoryRequest.type),
    mergeMap((action) => {
      const { uuid, page = 0, size = 10 } = action.payload;
      return observableGET(
        `/subscription/history/${uuid}?page=${page}&size=${size}`
      ).pipe(
        mergeMap((response) =>
          of(
            getUserSubscriptionHistorySuccess({
              ...response.data,
              page,
              size
            })
          )
        ),
        catchError((error) => of(getUserSubscriptionHistoryFailure(error)))
      );
    })
  );

export const createCustomerPortalSessionEpic = (action$) =>
  action$.pipe(
    ofType(createCustomerPortalSessionRequest.type),
    mergeMap((action) => {
      const { userId } = action.payload;

      return observableGET(
        `/stripe-subscription/${userId}/portal-session`
      ).pipe(
        mergeMap((response) =>
          of(createCustomerPortalSessionSuccess(response.data))
        ),
        catchError((error) => of(createCustomerPortalSessionFailure(error)))
      );
    })
  );

const userSubscriptionEpic = combineEpics(
  subscriptionPlanRequestEpic,
  userSubscriptionPaymentEpic,
  getUserSubscriptionEpic,
  cancelUserSubscriptionEpic,
  getUserSubscriptionHistoryEpic,
  createCustomerPortalSessionEpic
);

export default userSubscriptionEpic;
